import { render, staticRenderFns } from "./TableActions.vue?vue&type=template&id=24dbee3c&scoped=true&"
import script from "./TableActions.vue?vue&type=script&lang=js&"
export * from "./TableActions.vue?vue&type=script&lang=js&"
import style0 from "./TableActions.vue?vue&type=style&index=0&id=24dbee3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dbee3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24dbee3c')) {
      api.createRecord('24dbee3c', component.options)
    } else {
      api.reload('24dbee3c', component.options)
    }
    module.hot.accept("./TableActions.vue?vue&type=template&id=24dbee3c&scoped=true&", function () {
      api.rerender('24dbee3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/templates/TableActions.vue"
export default component.exports